import mapResponseToNotifications from '../mappers/mapResponseToNotifications'

export function mapResponseNotification(json) {
  try {
    return {
      count: json.count,
      countNotRead: json.countNotRead,
      countNotSeen: json.countNotSeen,
      deleted: json && json.deleted,
      items:
        json && json.items ? json.items.map(mapResponseToNotifications) : [],
    }
  } catch (e) {
    return {
      count: 0,
      countNotRead: 0,
      countNotSeen: 0,
      deleted: false,
      items: [],
    }
  }
}

export default async function(response: Response) {
  try {
    const json = await response.json()
    return {
      count: json.count,
      countNotRead: json.countNotRead,
      countNotSeen: json.countNotSeen,
      deleted: json && json.deleted,
      items:
        json && json.items ? json.items.map(mapResponseToNotifications) : [],
    }
  } catch (e) {
    return {
      count: 0,
      countNotRead: 0,
      countNotSeen: 0,
      deleted: false,
      items: [],
    }
  }
}
